import { motion } from "framer-motion";

// 3D animated TEMPEO logo mark — sphere with orbital rings
export default function Logo3D({ size = 40, withText = true }) {
  return (
    <div className="flex items-center gap-2.5" data-testid="logo">
      <div
        className="relative shrink-0"
        style={{ width: size, height: size }}
        aria-hidden="true"
      >
        {/* Glow background */}
        <motion.div
          className="absolute inset-0 rounded-full bg-gradient-to-br from-primary via-accent to-primary blur-md"
          animate={{ opacity: [0.5, 0.9, 0.5], scale: [0.9, 1.1, 0.9] }}
          transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
        />
        {/* Outer ring */}
        <motion.div
          className="absolute inset-0 rounded-full border border-primary/50"
          animate={{ rotate: 360 }}
          transition={{ duration: 14, repeat: Infinity, ease: "linear" }}
          style={{ boxShadow: "0 0 24px hsl(var(--primary) / 0.4)" }}
        >
          <div className="absolute -top-0.5 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-accent" style={{ boxShadow: "0 0 8px hsl(var(--accent))" }} />
        </motion.div>
        {/* Middle ring */}
        <motion.div
          className="absolute inset-1.5 rounded-full border border-accent/40"
          animate={{ rotate: -360 }}
          transition={{ duration: 10, repeat: Infinity, ease: "linear" }}
        >
          <div className="absolute -top-0.5 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-primary" />
        </motion.div>
        {/* Core */}
        <div className="absolute inset-[28%] rounded-full bg-gradient-to-br from-foreground to-primary" style={{ boxShadow: "inset 0 1px 2px rgba(255,255,255,0.4)" }} />
      </div>
      {withText && (
        <span className="font-heading font-bold text-xl tracking-tight">
          TEMPEO
        </span>
      )}
    </div>
  );
}
